import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

//dropdown EMPRESAS

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.tipoMaterial} value={props.elemento.descrMaterial}>{props.elemento.descrMaterial}</option>

  )
}; 

const ListaPro = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrProducto" id="miLista4" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  let numOC=""
  if(props.elemento.numOrdenCompra){
    numOC = "OC " + props.elemento.numOrdenCompra + " ==> " + props.elemento.descrEmpresa 
  }

  return (
    <option dato1={props.elemento.descrEmpresa} value={props.elemento.numOrdenCompra}>{numOC}</option>
  )
};

const ListaOC = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="numOrdenCompraCli" id="miLista" onChange={handleLista}>
        <option value="">Sin Proyecto</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  let canti=""
  if(props.elemento.cantidadAprob){
    canti = " ( " + props.elemento.cantidadAprob + " )"
  }
  return (
    <option value={props.elemento.descrProducto}>{props.elemento.descrProducto}{canti}</option>
  )
};

const ListaItem = ({list}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleNivel3 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrProductoOC" id="miLista5">
        <option value="">Consultar...</option>
        {Nivel3Detalle}
      </select>
    </div>
  )
};

const DetalleNivel4 = props => {
  // console.log(props.elemento)
  return (
    <option dato1={props.elemento._id} value={props.elemento.descrProducto}>{props.elemento.descrProducto}</option>
  )
};

const ListaCompra = ({list, handleLista}) => {
  console.log(list)
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleNivel4 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="solicCompra" id="miLista1" onChange={handleLista}>
        <option value="">Consultar...</option>
        {Nivel4Detalle}
      </select>
    </div>
  )
};

class AddItemCotiPro2 extends React.Component{
    state={argsAdd: {}, checked: false, producto: "", listaItem2: this.props.allLubricanteM.allLubricanteM}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    if(ev.target.name==="sacar"){
      this.setState({checked: ev.target.checked})
    }
    // if(ev.target.name==="solicCompra" && ev.target.value!=="Consultar..."){
    //   this.setState({producto: ev.target.value})
    // }
    this.setState({argsAdd})
  }

  render(){
    const {checked, argsAdd} = this.state;
    if(checked===true){
      argsAdd.sacar = "S"
    }else{
      argsAdd.sacar = "N"
    }
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)
    args._id = this.props.idLista._id
    args.numCoti = this.props.idLista.numCoti
    let list1 = [], listCompra = []
    if(this.props.allCotizacionRtesItemPro.allCotizacionRtes){list1 = this.props.allCotizacionRtesItemPro.allCotizacionRtes}
    if(this.props.allSolicCompra.allSolicCompra){listCompra = this.props.allSolicCompra.allSolicCompra}
    console.log(args)
    let listI = []
    if(this.props.allCotizacionRtesI.allCotizacionRtes){listI = this.props.allCotizacionRtesI.allCotizacionRtes}
    let listPrI=[]
    if (args.numOrdenCompraCli){
      let numOrdenCompra=parseInt(args.numOrdenCompraCli)
      listPrI = listI.filter(elemento => elemento.numOrdenCompra===numOrdenCompra)
    }  
    let listPro=this.state.listaItem2
    // let listaItem2=this.state.listaItem2
    console.log(listPro)
    let buscItem = ''
    if(args.descrProductoB){
      buscItem = args.descrProductoB
    }
    // listPro = listaItem2.filter(elemento => elemento.tipoProducto===this.props.tipoC && elemento.estado==='Activo')
    if(buscItem){
      listPro = listPro.filter(elemento => elemento.descrMaterial.toLowerCase().indexOf(buscItem.toLowerCase()) > -1)
    }
    console.log(listPro)

    return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Item nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '25%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Proyecto destino</label>
                  <ListaOC list={list1} handleLista={this.props.handleLista1} />
                </Form.Field>    
              </div>
              <div className="column" style={{width: '75%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Items del proyecto</label>
                  <ListaItem list={listPrI}/>
                </Form.Field>    
              </div>
            </div>
          {/* </div>
          <div className="ui three column stackable grid"> */}
            <div className="row container">
              <div className="column" style={{width: '80%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Solicitudes de compra de otras áreas</label>
                  <ListaCompra list={listCompra} handleLista={this.props.handleLista2}/>
                </Form.Field>    
              </div>
              <div className="column" style={{width: '1%'}}>
                <Form.Field>
                <br/>
                    <input type='checkbox' id="sacar" name="sacar" style={this.props.styles.input} checked={checked} onChange={this.handleChange}/>
                </Form.Field>
              </div>
              <div className="column" style={{width: '17%'}}>                
                <Form.Field>
                <br/>
                  <p style={{color: '#302b63', fontSize: '1.0em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    &nbsp;Eliminar item de la lista
                  </p> 
                </Form.Field>    
              </div>
            </div>
          {/* </div>
          <div className="ui four column stackable grid"> */}
            <div className="row container">
              <div className="column" style={{width: '29%'}}>                
                <Form.Field>
                  <div className="ui input fluid">
                    <input id='descrProductoB' autoComplete="off" name="descrProductoB" type="text" placeholder="Buscar material" style={this.props.styles.dropdown} onChange={this.props.handleChange}/>
                  </div>
                </Form.Field>    
              </div>
            </div>
            <div className="row container">
              <div className="column" style={{width: '76%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Material/Equipo</label>
                  <ListaPro list={listPro} handleLista={this.props.handleLista} />
                </Form.Field>    
              </div>
              <div className="column" style={{width: '12%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad compra</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadCoti" id="cantidadCoti" placeholder='Cantidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '12%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad proyecto</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadOC" id="cantidadOC" placeholder='Cantidad proyecto' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allMaterial, {name:'allMaterial'}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesItemPro',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: {$in: ['Creada', 'Aprobada', 'Finalizada']}}}]`
  }}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesI',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: {$in: ['Creada', 'Aprobada', 'Finalizada']}}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1, 
      tipoCoti: 1, numOrdenCompra: 1, descrProducto: '$itemsCoti.descrProducto', descrCorta: '$itemsCoti.descrCorta', cantidadAprob: '$itemsCoti.cantidadAprob'}},   
      {$sort: {descrProducto: 1}}
    ]`}}}}),
  graphql(queries.query.allSolicCompra, {name:'allSolicCompra',
    options: (props) => {return {variables: {tipoqry: `[{$match: {activo: 'S'}}]`
  }}}}),

  )(AddItemCotiPro2)
